import { apiClient } from './client';

export interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  data?: any;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
  businessAccountId?: string | null;
  workspaceId?: string | null;
  organizationId?: string | null;
  userId?: string;
}

export interface NotificationResponse {
  success?: boolean;
  data: Notification[];
  count?: number;
  unreadCount?: number;
  error?: string | null;
  totalCount?: number;
  filteredTotalCount?: number;
  hasMore?: boolean;
  message?: string;
}

export interface NotificationQuery {
  workspaceId?: string;
  type?: string;
  isRead?: boolean;
  limit?: number;
  offset?: number;
  orderBy?: string;
  ascending?: boolean;
}

export const notificationsApi = {
  getAll: async (query: NotificationQuery = {}): Promise<NotificationResponse> => {
    const params = new URLSearchParams();
    
    if (query.workspaceId) params.append('workspace_id', query.workspaceId);
    if (query.type) params.append('type', query.type);
    if (query.isRead !== undefined) params.append('isRead', query.isRead.toString());
    if (query.limit) params.append('limit', query.limit.toString());
    if (query.offset) params.append('offset', query.offset.toString());
    if (query.orderBy) params.append('orderBy', query.orderBy);
    if (query.ascending !== undefined) params.append('ascending', query.ascending.toString());

    const response = await apiClient.get(`/notifications?${params.toString()}`);
    return response;
  },

  getById: async (id: string): Promise<{ success: boolean; data: Notification }> => {
    const response = await apiClient.get(`/notifications/${id}`);
    return response.data;
  },

  markAsRead: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.put(`/notifications/${id}/read`);
    return response.data;
  },

  markAllAsRead: async (query: { workspaceId?: string; type?: string } = {}): Promise<{ success: boolean; message: string; updatedCount: number }> => {
    const params = new URLSearchParams();

    if (query.workspaceId) params.append('workspace_id', query.workspaceId);
    if (query.type) params.append('type', query.type);

    const response = await apiClient.post(`/notifications/read-all?${params.toString()}`);
    return response.data;
  },

  delete: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete(`/notifications/${id}`);
    return response.data;
  },
};
